import i18n from "i18next";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";

// Fluent UI Imports
import { Field, Input, MessageBar } from "@fluentui/react-components";

interface IChangePasswordProps {
  userName: string;
  onDismiss: any;
  saveDisabled(item: boolean): void;
  newMail(item: string): void;
}

var emailRegEx = /\S+@\S+\.\S+/;

function ChangeMail(props: IChangePasswordProps) {
  const [newMail, setNewMail] = useState("");
  const [confirmNewMail, setConfirmNewMail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const CheckValidEMail = () => {
    if (!emailRegEx.test(newMail)) {
      setErrorMessage(i18n.t<string>("enterValidEMail"));
    } else if (newMail.length == 0) {
      setErrorMessage(i18n.t<string>("enterValidEMail"));
    } else if (newMail != confirmNewMail) {
      setErrorMessage(i18n.t<string>("eMailNotTheSame"));
    } else {
      setErrorMessage("");
    }
  };

  useEffect(() => {
    props.newMail(newMail);
  }, [newMail]);

  useEffect(() => {
    if (
      errorMessage != "" ||
      successMessage != "" ||
      newMail == "" ||
      confirmNewMail == ""
    ) {
      props.saveDisabled(true);
    } else props.saveDisabled(false);
  }, [errorMessage, successMessage, newMail, confirmNewMail]);

  useEffect(() => {
    if (newMail != "" && confirmNewMail != "") {
      CheckValidEMail();
    }
  }, [newMail, confirmNewMail]);

  return (
    <div>
      <Field label={i18n.t<string>("currentMail")}>
        <Input value={props.userName} readOnly></Input>
      </Field>
      <Field label={i18n.t<string>("newMail")}>
        <Input
          placeholder={i18n.t<string>("newMail")}
          onChange={(ev, val) => setNewMail(val.value ? val.value : "")}
          value={newMail}
        ></Input>
      </Field>
      <Field
        label={i18n.t<string>("confirmNewMail")}
        style={{ marginBottom: "5px" }}
      >
        <Input
          placeholder={i18n.t<string>("confirmNewMail")}
          onChange={(ev, val) => setConfirmNewMail(val.value ? val.value : "")}
          value={confirmNewMail}
        ></Input>
      </Field>
      {errorMessage != "" && (
        <MessageBar intent={"error"}>{i18n.t<string>(errorMessage)}</MessageBar>
      )}

      {successMessage != "" && (
        <MessageBar intent={"success"}>
          {i18n.t<string>(successMessage)}
        </MessageBar>
      )}
      <div
        style={{
          width: "100%",
          marginTop: "5px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {/* <Button
          icon={<MailEditRegular />}
          appearance="primary"
          disabled={
            errorMessage != "" ||
            successMessage != "" ||
            newMail == "" ||
            confirmNewMail == ""
          }
          onClick={() => {
            changeMail();
          }}
        >
          {i18n.t<string>("changeMail")}
        </Button> */}
      </div>
    </div>
  );
}

export default ChangeMail;
